<div class="foreign-pair-notice" *ngIf="show" role="note">
  <svg
    class="foreign-pair-notice__icon"
    viewBox="0 0 24 24"
    width="18"
    height="18"
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
    />
  </svg>
  <p class="foreign-pair-notice__text">
    <strong>{{ 'FOREIGN_PAIR_NOTICE.TITLE' | translate }}</strong>
    {{ 'FOREIGN_PAIR_NOTICE.MESSAGE' | translate }}
  </p>
</div>
